import React, { useState, useEffect } from 'react';

import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService } from '../service/AuthorizationService';
import { ClientLogin } from './ClientLogin';
import { RootLogin } from './RootLogin';
import { ClientPasswordReset } from './ClientPasswordReset';
import { PasswordReset } from './PasswordReset';

export function URLResolver(props){

    const { origin, pathname } = window.location;
    
    const [loading, setLoading] = useState(true);
    const [client, setClient] = useState(null);
    const authorizationService = new AuthorizationService();

    useEffect(() => {
        async function fetchData() {
            setClient(await authorizationService.getClientByURL(origin, pathname.split("/")[1] || ""));
            setLoading(false);
        }        
        fetchData();
    }, []);

    const goToLogin = () => {
        if(client){
            if(client.use_custom_url){
                window.location.href = client.custom_url;
            }
            else {
                window.location.href = `/${client.shortcode}`;
            }
        }
        else {
            window.location.href = "/";
        }
    }

    if(loading){
        return <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
            <ProgressSpinner strokeWidth="5"/>
        </div>
    }

    if(pathname.endsWith("/password-reset")){
        const token = window.location.search.substr(1) || "";
        if(client){
            return <ClientPasswordReset client={client} token={token} onPasswordCreated={goToLogin}/>
        }
        
        return <PasswordReset token={token} onPasswordCreated={goToLogin}/>
    }

    if(client){
        return <ClientLogin client={client}  onAuthenticated={props.onAuthenticated}/>
    }
    
    return <RootLogin client={client}  onAuthenticated={props.onAuthenticated}/>
}